export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticSlider.vue?vue&type=template&id=75f1b323"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-slider/VuesticSlider.vue?vue&type=template&id=75f1b323
// module id = 9WBR
// module chunks = 41